module.exports = __webpack_public_path__ + "img/Icon_ZWING_offline.c3eaee88.svg";